export class ServiceConfig {
  defaultProductService?: number;
  acceptMultipleCustomerOnInvoicing: boolean = false;
  generateInvoice?: boolean = true;
  paymentTermsDays?: number;
  durationStep?: number = 0.5;
}
